/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { KakaoAddressResponse } from '../models/kakao-address-response';
import { kakaoAuthControllerConnect } from '../fn/kakao/kakao-auth-controller-connect';
import { KakaoAuthControllerConnect$Params } from '../fn/kakao/kakao-auth-controller-connect';
import { kakaoAuthControllerLogin } from '../fn/kakao/kakao-auth-controller-login';
import { KakaoAuthControllerLogin$Params } from '../fn/kakao/kakao-auth-controller-login';
import { kakaoAuthControllerLoginWithIos } from '../fn/kakao/kakao-auth-controller-login-with-ios';
import { KakaoAuthControllerLoginWithIos$Params } from '../fn/kakao/kakao-auth-controller-login-with-ios';
import { kakaoAuthControllerSearchAddress } from '../fn/kakao/kakao-auth-controller-search-address';
import { KakaoAuthControllerSearchAddress$Params } from '../fn/kakao/kakao-auth-controller-search-address';
import { kakaoAuthControllerTest } from '../fn/kakao/kakao-auth-controller-test';
import { KakaoAuthControllerTest$Params } from '../fn/kakao/kakao-auth-controller-test';
import { OAuthResponseDto } from '../models/o-auth-response-dto';
import { UserDto } from '../models/user-dto';

@Injectable({ providedIn: 'root' })
export class KakaoService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `kakaoAuthControllerTest()` */
  static readonly KakaoAuthControllerTestPath = '/api/oauth/kakao/test';

  /**
   * 카카오 로그인.
   *
   * 카카오 로그인을 수행합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `kakaoAuthControllerTest()` instead.
   *
   * This method doesn't expect any request body.
   */
  kakaoAuthControllerTest$Response(params?: KakaoAuthControllerTest$Params, context?: HttpContext): Observable<StrictHttpResponse<OAuthResponseDto>> {
    return kakaoAuthControllerTest(this.http, this.rootUrl, params, context);
  }

  /**
   * 카카오 로그인.
   *
   * 카카오 로그인을 수행합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `kakaoAuthControllerTest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  kakaoAuthControllerTest(params?: KakaoAuthControllerTest$Params, context?: HttpContext): Observable<OAuthResponseDto> {
    return this.kakaoAuthControllerTest$Response(params, context).pipe(
      map((r: StrictHttpResponse<OAuthResponseDto>): OAuthResponseDto => r.body)
    );
  }

  /** Path part for operation `kakaoAuthControllerLogin()` */
  static readonly KakaoAuthControllerLoginPath = '/api/oauth/kakao/signin';

  /**
   * 카카오 로그인.
   *
   * 카카오 로그인을 수행합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `kakaoAuthControllerLogin()` instead.
   *
   * This method doesn't expect any request body.
   */
  kakaoAuthControllerLogin$Response(params: KakaoAuthControllerLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<OAuthResponseDto>> {
    return kakaoAuthControllerLogin(this.http, this.rootUrl, params, context);
  }

  /**
   * 카카오 로그인.
   *
   * 카카오 로그인을 수행합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `kakaoAuthControllerLogin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  kakaoAuthControllerLogin(params: KakaoAuthControllerLogin$Params, context?: HttpContext): Observable<OAuthResponseDto> {
    return this.kakaoAuthControllerLogin$Response(params, context).pipe(
      map((r: StrictHttpResponse<OAuthResponseDto>): OAuthResponseDto => r.body)
    );
  }

  /** Path part for operation `kakaoAuthControllerSearchAddress()` */
  static readonly KakaoAuthControllerSearchAddressPath = '/api/oauth/kakao/search';

  /**
   * 주소 검색.
   *
   * 입력한 주소와 일치하는 주소를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `kakaoAuthControllerSearchAddress()` instead.
   *
   * This method doesn't expect any request body.
   */
  kakaoAuthControllerSearchAddress$Response(params?: KakaoAuthControllerSearchAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<KakaoAddressResponse>> {
    return kakaoAuthControllerSearchAddress(this.http, this.rootUrl, params, context);
  }

  /**
   * 주소 검색.
   *
   * 입력한 주소와 일치하는 주소를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `kakaoAuthControllerSearchAddress$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  kakaoAuthControllerSearchAddress(params?: KakaoAuthControllerSearchAddress$Params, context?: HttpContext): Observable<KakaoAddressResponse> {
    return this.kakaoAuthControllerSearchAddress$Response(params, context).pipe(
      map((r: StrictHttpResponse<KakaoAddressResponse>): KakaoAddressResponse => r.body)
    );
  }

  /** Path part for operation `kakaoAuthControllerLoginWithIos()` */
  static readonly KakaoAuthControllerLoginWithIosPath = '/api/oauth/kakao/ios/signin';

  /**
   * IOS 카카오 로그인.
   *
   * IOS 카카오 로그인을 수행합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `kakaoAuthControllerLoginWithIos()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  kakaoAuthControllerLoginWithIos$Response(params: KakaoAuthControllerLoginWithIos$Params, context?: HttpContext): Observable<StrictHttpResponse<OAuthResponseDto>> {
    return kakaoAuthControllerLoginWithIos(this.http, this.rootUrl, params, context);
  }

  /**
   * IOS 카카오 로그인.
   *
   * IOS 카카오 로그인을 수행합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `kakaoAuthControllerLoginWithIos$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  kakaoAuthControllerLoginWithIos(params: KakaoAuthControllerLoginWithIos$Params, context?: HttpContext): Observable<OAuthResponseDto> {
    return this.kakaoAuthControllerLoginWithIos$Response(params, context).pipe(
      map((r: StrictHttpResponse<OAuthResponseDto>): OAuthResponseDto => r.body)
    );
  }

  /** Path part for operation `kakaoAuthControllerConnect()` */
  static readonly KakaoAuthControllerConnectPath = '/api/oauth/kakao/connect';

  /**
   * 카카오 계정 연결.
   *
   * 기존 계정에 소셜 계정을 연결합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `kakaoAuthControllerConnect()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  kakaoAuthControllerConnect$Response(params: KakaoAuthControllerConnect$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return kakaoAuthControllerConnect(this.http, this.rootUrl, params, context);
  }

  /**
   * 카카오 계정 연결.
   *
   * 기존 계정에 소셜 계정을 연결합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `kakaoAuthControllerConnect$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  kakaoAuthControllerConnect(params: KakaoAuthControllerConnect$Params, context?: HttpContext): Observable<UserDto> {
    return this.kakaoAuthControllerConnect$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

}
